import { render } from "./FixedNav.vue?vue&type=template&id=4f5b47f0&scoped=true"
import script from "./FixedNav.vue?vue&type=script&lang=js"
export * from "./FixedNav.vue?vue&type=script&lang=js"

import "./FixedNav.vue?vue&type=style&index=0&id=4f5b47f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5b47f0"]])

export default __exports__